// Sample data for testing the category carousel component

export const sampleChannelData = [
    {
      id: 1,
      name: 'HBO',
      logoUrl: 'https://img10.hotstar.com/image/upload/f_auto,q_90,w_1080/sources/r1/cms/prod/5731/1739780835731-a',
      routerLink: '/tqr/channel',
      queryParams: { channelId: 1, channelName: 'Star Plus' }
    },
    {
      id: 2,
      name: 'Peacock',
      logoUrl: 'https://img10.hotstar.com/image/upload/f_auto,q_90,w_640/sources/r1/cms/prod/7816/1739359307816-a',
      routerLink: '/tqr/channel',
      queryParams: { channelId: 2, channelName: 'Sony TV' }
    },
    {
      id: 3,
      name: 'Disney+',
      logoUrl: 'https://img10.hotstar.com/image/upload/f_auto,q_90,w_640/sources/r1/cms/prod/3703/1747996723703-a',
      routerLink: '/tqr/channel',
      queryParams: { channelId: 3, channelName: 'Zee TV' }
    },
    {
      id: 4,
      name: 'Paramount',
      logoUrl: 'https://img10.hotstar.com/image/upload/f_auto,q_90,w_1080/sources/r1/cms/prod/583/1739358280583-a',
      routerLink: '/tqr/channel',
      queryParams: { channelId: 4, channelName: 'Colors TV' }
    },
    {
      id: 5,
      name: 'Star Gold',
      logoUrl: 'https://via.placeholder.com/80x80/BB8FCE/FFFFFF?text=GOLD',
      routerLink: '/tqr/channel',
      queryParams: { channelId: 5, channelName: 'Star Gold' }
    },
    {
      id: 6,
      name: 'Discovery',
      logoUrl: 'https://via.placeholder.com/80x80/85C1E9/FFFFFF?text=DISC',
      routerLink: '/tqr/channel',
      queryParams: { channelId: 6, channelName: 'Discovery' }
    },
    {
      id: 7,
      name: 'National Geographic',
      logoUrl: 'https://via.placeholder.com/80x80/F4D03F/000000?text=NAT+GEO',
      routerLink: '/tqr/channel',
      queryParams: { channelId: 7, channelName: 'National Geographic' }
    },
    {
      id: 8,
      name: 'ESPN',
      logoUrl: 'https://via.placeholder.com/80x80/E74C3C/FFFFFF?text=ESPN',
      routerLink: '/tqr/channel',
      queryParams: { channelId: 8, channelName: 'ESPN' }
    }
  ];
  
  export const sampleGenreData = [
    {
      id: 1,
      name: 'Reality',
      imageUrl: 'https://img10.hotstar.com/image/upload/f_auto,q_90,w_640/sources/r1/cms/prod/5264/1535264-a-9e7871687c76',
      routerLink: '/tqr/genre',
      queryParams: { genreId: 1, genreName: 'Action' }
    },
    {
      id: 2,
      name: 'Romance',
      imageUrl: 'https://img10.hotstar.com/image/upload/f_auto,q_90,w_1080/sources/r1/cms/prod/1112/1750239101112-a',
      routerLink: '/tqr/genre',
      queryParams: { genreId: 2, genreName: 'Romance' }
    },
    {
      id: 3,
      name: 'Family',
      imageUrl: 'https://img10.hotstar.com/image/upload/f_auto,q_90,w_1080/sources/r1/cms/prod/5284/1535284-a-656c6b45a905',
      routerLink: '/tqr/genre',
      queryParams: { genreId: 3, genreName: 'Comedy' }
    },
    {
      id: 4,
      name: 'Drama',
      imageUrl: 'https://img10.hotstar.com/image/upload/f_auto,q_90,w_1080/sources/r1/cms/prod/5285/1535285-a-88035ca1ae69',
      routerLink: '/tqr/genre',
      queryParams: { genreId: 4, genreName: 'Drama' }
    },
    {
      id: 5,
      name: 'Comedy',
      imageUrl: 'https://img10.hotstar.com/image/upload/f_auto,q_90,w_640/sources/r1/cms/prod/5292/1535292-a-5739f9c84b63',
      routerLink: '/tqr/genre',
      queryParams: { genreId: 5, genreName: 'Thriller' }
    },
    {
      id: 6,
      name: 'Crime',
      imageUrl: 'https://img10.hotstar.com/image/upload/f_auto,q_90,w_1080/sources/r1/cms/prod/5288/1535288-a-690bac400aa1',
      routerLink: '/tqr/genre',
      queryParams: { genreId: 6, genreName: 'Horror' }
    },
    {
      id: 7,
      name: 'Food',
      imageUrl: 'https://img10.hotstar.com/image/upload/f_auto,q_90,w_1080/sources/r1/cms/prod/5281/1535281-a-b56dc39e5bb7',
      routerLink: '/tqr/genre',
      queryParams: { genreId: 7, genreName: 'Sci-Fi' }
    },
    {
      id: 8,
      name: 'Action',
      imageUrl: 'https://img10.hotstar.com/image/upload/f_auto,q_90,w_1080/sources/r1/cms/prod/5302/1535302-a-e90748391e0d',
      routerLink: '/tqr/genre',
      queryParams: { genreId: 8, genreName: 'Documentary' }
    },
    {
        id: 9,
        name: 'Teen',
        imageUrl: 'https://img10.hotstar.com/image/upload/f_auto,q_90,w_1080/sources/r1/cms/prod/5248/1535248-a-35ccd1ea9ec0',
        routerLink: '/tqr/genre',
        queryParams: { genreId: 9, genreName: 'Teen' }
    },
    {
        id: 10,
        name: 'Travel',
        imageUrl: 'https://img10.hotstar.com/image/upload/f_auto,q_90,w_1080/sources/r1/cms/prod/5245/1535245-a-90839834c474',
        routerLink: '/tqr/genre',
        queryParams: { genreId: 10, genreName: 'Travel' }
    },
  ];
  
  export const sampleLanguageData = [
    {
      id: 1,
      name: 'Hindi',
      nativeName: 'हिंदी',
      englishName: 'Hindi',
      imageUrl: 'https://img10.hotstar.com/image/upload/f_auto,q_90,w_1080/sources/r1/cms/prod/6661/1526661-a-00b818b5bc0e',
      routerLink: '/tqr/language',
      queryParams: { languageId: 1, languageName: 'Hindi' }
    },
    {
      id: 2,
      name: 'Tamil',
      nativeName: 'தமிழ்',
      englishName: 'Tamil',
      imageUrl: 'https://img10.hotstar.com/image/upload/f_auto,q_90,w_640/sources/r1/cms/prod/6682/1526682-a-fd4e220ba563',
      routerLink: '/tqr/language',
      queryParams: { languageId: 2, languageName: 'Tamil' }
    },
    {
      id: 3,
      name: 'Telgu',
      nativeName: 'తెలుగు',
      englishName: 'Telgu',
      imageUrl: 'https://img10.hotstar.com/image/upload/f_auto,q_90,w_640/sources/r1/cms/prod/6685/1526685-a-5f5995a53f61',
      routerLink: '/tqr/language',
      queryParams: { languageId: 3, languageName: 'Telgu' }
    },
    {
      id: 4,
      name: 'Malayalam',
      nativeName: 'മലയാളം',
      englishName: 'Malayalam',
      imageUrl: 'https://img10.hotstar.com/image/upload/f_auto,q_90,w_1080/sources/r1/cms/prod/6672/1526672-a-eafe6913c6c8',
      routerLink: '/tqr/language',
      queryParams: { languageId: 4, languageName: 'Malayalam' }
    },
    {
      id: 5,
      name: 'Kannada',
      nativeName: 'ಕನ್ನಡ',
      englishName: 'Kannada',
      imageUrl: 'https://img10.hotstar.com/image/upload/f_auto,q_90,w_1080/sources/r1/cms/prod/8124/1714043448124-a',
      routerLink: '/tqr/language',
      queryParams: { languageId: 5, languageName: 'Kannada' }
    },
    {
      id: 6,
      name: 'Bengali',
      nativeName: 'বাংলা',
      englishName: 'Bengali',
      imageUrl: 'https://img10.hotstar.com/image/upload/f_auto,q_90,w_640/sources/r1/cms/prod/6659/1526659-a-7271cf19114e',
      routerLink: '/tqr/language',
      queryParams: { languageId: 6, languageName: 'Bengali' }
    },
    {
      id: 7,
      name: 'Marathi',
      nativeName: 'मराठी',
      englishName: 'Marathi',
      imageUrl: 'https://img10.hotstar.com/image/upload/f_auto,q_90,w_1080/sources/r1/cms/prod/6674/1526674-a-fdd5233a7699',
      routerLink: '/tqr/language',
      queryParams: { languageId: 7, languageName: 'Marathi' }
    },
    {
      id: 8,
      name: 'English',
      nativeName: 'English',
      englishName: 'English',
      imageUrl: 'https://img10.hotstar.com/image/upload/f_auto,q_90,w_640/sources/r1/cms/prod/6660/1526660-a-afdd1ecfd8ae',
      routerLink: '/tqr/language',
      queryParams: { languageId: 8, languageName: 'Gujarati' }
    },
    {
        id: 9,
        name: 'Japanese',
        nativeName: 'English',
        englishName: 'Japanese',
        imageUrl: 'https://img10.hotstar.com/image/upload/f_auto,q_90,w_1080/sources/r1/cms/prod/9896/1750233039896-a',
        routerLink: '/tqr/language',
        queryParams: { languageId: 9, languageName: 'Japanese' }
    },
    {
        id: 10,
        name: 'Korean',
        nativeName: 'English',
        englishName: 'Korean',
        imageUrl: 'https://img10.hotstar.com/image/upload/f_auto,q_90,w_1080/sources/r1/cms/prod/6670/1526670-a-ec8fb58a5fb8',
        routerLink: '/tqr/language',
        queryParams: { languageId: 10, languageName: 'Korean' }
    },
  ];
  
  export const sampleMixedData = [
    // Channels
    {
      id: 'ch1',
      name: 'Star Plus',
      itemType: 'channel' as const,
      logoUrl: 'https://via.placeholder.com/80x80/FF6B6B/FFFFFF?text=STAR+',
      routerLink: '/tqr/channel',
      queryParams: { channelId: 1, channelName: 'Star Plus' }
    },
    {
      id: 'ch2',
      name: 'Sony TV',
      itemType: 'channel' as const,
      logoUrl: 'https://via.placeholder.com/80x80/4ECDC4/FFFFFF?text=SONY',
      routerLink: '/tqr/channel',
      queryParams: { channelId: 2, channelName: 'Sony TV' }
    },
    
    // Genres
    {
      id: 'g1',
      name: 'Action',
      itemType: 'genre' as const,
      imageUrl: 'https://images.unsplash.com/photo-1489599735734-79b4d2fa3b8c?w=300&h=200&fit=crop',
      routerLink: '/tqr/genre',
      queryParams: { genreId: 1, genreName: 'Action' }
    },
    {
      id: 'g2',
      name: 'Romance',
      itemType: 'genre' as const,
      imageUrl: 'https://images.unsplash.com/photo-1518568814500-bf0f8d125f46?w=300&h=200&fit=crop',
      routerLink: '/tqr/genre',
      queryParams: { genreId: 2, genreName: 'Romance' }
    },
    
    // Languages
    {
      id: 'l1',
      name: 'Hindi',
      nativeName: 'हिंदी',
      englishName: 'Hindi',
      itemType: 'language' as const,
      imageUrl: 'https://images.unsplash.com/photo-1524492412937-b28074a5d7da?w=300&h=200&fit=crop',
      routerLink: '/tqr/language',
      queryParams: { languageId: 1, languageName: 'Hindi' }
    },
    {
      id: 'l2',
      name: 'Tamil',
      nativeName: 'தமிழ்',
      englishName: 'Tamil',
      itemType: 'language' as const,
      imageUrl: 'https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=300&h=200&fit=crop',
      routerLink: '/tqr/language',
      queryParams: { languageId: 2, languageName: 'Tamil' }
    },
    
    // More mixed content
    {
      id: 'ch3',
      name: 'Colors TV',
      itemType: 'channel' as const,
      logoUrl: 'https://via.placeholder.com/80x80/F7DC6F/000000?text=COLORS',
      routerLink: '/tqr/channel',
      queryParams: { channelId: 4, channelName: 'Colors TV' }
    },
    {
      id: 'g3',
      name: 'Comedy',
      itemType: 'genre' as const,
      imageUrl: 'https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?w=300&h=200&fit=crop',
      routerLink: '/tqr/genre',
      queryParams: { genreId: 3, genreName: 'Comedy' }
    }
  ];